// src/stone/illustrations/CoinsIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CoinsIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 112 110",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M67.727 28.77c0 1.743-.162 3.453-.463 5.1a27 27 0 0 1-1.12 4.26 22 22 0 0 1-.67 1.727c-.135.348-.294.695-.459 1.04-.26.544-.526 1.083-.827 1.617-.18.326-.355.644-.554.958-4.991 8.307-14.085 13.864-24.462 13.862l-10.34-.003-.103-32.644L28.65 3.39l2.584-.002 19.55-.757q.618.278 1.229.585c.703.35 1.391.73 2.05 1.142q-9.926.478-19.855.965c-.819.039-.804 1.315.02 1.278 7.2-.355 14.412-.705 21.618-1.06.07.053.147.107.218.161a28.5 28.5 0 0 1 11.104 17.355c.365 1.84.561 3.752.559 5.711"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M55.565 38.801C49.994 53.562 33.528 61.032 18.786 55.49a28.3 28.3 0 0 1-9.965-6.36 28.5 28.5 0 0 1-5.883-8.404l6.804-5.155q-.533-1.501-.826-3.074l-7.1 5.38q-.301-.896-.541-1.807a1 1 0 0 0 .093-.056l7.102-5.383.096-1.595-.83.622-6.772 5.129a28.51 28.51 0 0 1 1.166-15.93c.02-.043.031-.087.051-.132C6.217 8.035 15.97 1.167 26.643.298a27 27 0 0 1 2.004-.09L39.114.194h.138c2.412.003 4.758.301 6.992.867 1.016.26 2.016.57 2.98.93q.788.301 1.56.64l-9.549.37a28 28 0 0 1 3.245 1.82q4.792-.233 9.584-.463c.01 0 .015.007.022.01q.911.553 1.761 1.173-4.835.238-9.674.472a28.3 28.3 0 0 1 7.724 8.979C57.76 22.04 58.632 30.68 55.565 38.8"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "M15.162 42.688h-.001a19.5 19.5 0 0 1-4.54-6.982 20 20 0 0 1-.653-2.061L38.705 11.88q.943.543 1.807 1.185a19.44 19.44 0 0 1 5.85 7.007L15.755 43.25a16 16 0 0 1-.593-.56ZM2.648 38.739a38 38 0 0 1-.245-.679l6.183-4.684q.231 1.024.563 2.015l-6.012 4.556q-.26-.6-.489-1.208Z"
        }
      ),
      /* @__PURE__ */ jsx("mask", { id: "coins_Illustration_svg__a", fill: "#fff", children: /* @__PURE__ */ jsx("path", { d: "m1.815 37.88.015.05-.018-.05z" }) }),
      /* @__PURE__ */ jsx("path", { fill: "#FCFCFC", d: "m1.815 37.88.015.05-.018-.05z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m1.815 37.88.961-.275-.207-.725h-.754zm.015.05-.92.393 1.881-.668zm-.018-.05v-1H.488l.364 1.275zm-.959.275.014.044.001.005 1.923-.55-.013-.043-.002-.006zm1.896-.62a1 1 0 0 1 .025.07l-1.923.55q.018.07.06.168zm-.937 1.345h.003v-2h-.002z",
          mask: "url(#coins_Illustration_svg__a)"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M27.642 42.103a9.7 9.7 0 0 1-3.26-.583c-4.046-1.453-6.177-5.72-5.9-9a.368.368 0 0 1 .732.061c-.255 3.007 1.702 6.913 5.415 8.248 2.675.96 5.438.625 7.39-.894 1.474-1.149 2.22-2.824 2.05-4.6-.326-3.347-2.389-4.817-5.002-6.673l-.24-.17c-2.67-1.902-4.888-3.715-4.989-6.659-.066-1.932.808-3.705 2.398-4.864 1.883-1.374 4.5-1.658 6.995-.761 2.973 1.068 4.592 3.708 5.114 5.824a.368.368 0 1 1-.716.176c-.477-1.93-1.95-4.337-4.65-5.307-2.3-.825-4.602-.583-6.314.663-1.39 1.014-2.153 2.562-2.097 4.245.09 2.613 2.084 4.237 4.683 6.086l.237.17c2.658 1.887 4.95 3.518 5.308 7.202.198 2.03-.652 3.946-2.33 5.251-1.344 1.043-3.034 1.585-4.824 1.585"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M23.319 44.353a.368.368 0 0 1-.348-.492l10.837-30.303a.368.368 0 0 1 .693.247L23.664 44.111a.37.37 0 0 1-.345.242"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "M1.52 34.993 8 30.083l-.017.288-6.41 4.858z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M14.856 43.832a.37.37 0 0 1-.252-.1 20.7 20.7 0 0 1-5.21-8.039 20.54 20.54 0 0 1-.538-12.05 22 22 0 0 1 .68-2.152 20.6 20.6 0 0 1 3.594-6.099.366.366 0 1 1 .558.475 19.9 19.9 0 0 0-4.12 7.958 19.8 19.8 0 0 0 .52 11.618 20 20 0 0 0 5.023 7.752c.147.14.152.372.012.52a.36.36 0 0 1-.267.117"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M86.845 39.61v69.862h-81.3V91.718H0v-17.01h5.552V57.334h52.27V39.609z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "M92.99 108.972V40.109h6.955v68.863zM87.345 108.972V40.109h1.922v68.863z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M106.443 56.619v18.094H112v17.012h-5.557v17.747h-5.998V39.609H112v17.01zM92.49 39.61h-2.72v69.862h2.72z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#1D232A", d: "M57.822 73.99h-2.777v18.203h2.777z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M45.243 109.472h9.804V57.334h-2.633l-2.216 16.115-.262 1.9-2.217 16.111-.262 1.901z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M106.442 73.976v.735H5.552q-.013 0-.025-.003h.025v-.732zM106.443 56.6h-48.62v.734h48.62zM106.443 91.723H5.545v.734h100.898z"
        }
      )
    ]
  }
);
var CoinsIllustration_default = CoinsIllustration;

export {
  CoinsIllustration,
  CoinsIllustration_default
};
